<div class="page page--partner-analytics">
  <div class="page__container">
    <h1 class="page__title mb-5 h2" translate>sms_campaigns_richsms_stats_action</h1>
    <div class="mb-5">
      <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device" [(activeId)]="activeId">
        <li [ngbNavItem]="1">
          <a ngbNavLink translate>stats_richsms_details_clic_title</a>
          <ng-template ngbNavContent>
            <wsb-click-statistics [uuidMessage]="uuidMessage"></wsb-click-statistics>
          </ng-template>
        </li>

        <li [ngbNavItem]="2">
          <a ngbNavLink translate>stats_richsms_details_devices_title</a>
          <ng-template ngbNavContent>
            <wsb-device-statistics [uuidMessage]="uuidMessage"></wsb-device-statistics>
          </ng-template>
        </li>
      </ul>
    </div>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>

    <div class="page__actions  actions-bar" #actionsBar style="z-index: 1">
      <span class="actions-bar__bg"></span>
      <div class="actions-bar__container" toastContainer></div>
      <div class="actions-bar__container  actions-bar__container--actions">
        <div class="d-flex">
          <button #submitBtn (click)="goBack()" class="btn  btn-secondary ms-3 btn-sm" translate>common_back</button>
        </div>
      </div>
    </div>
  </div>
</div>
